// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_d-0";
export var skeletonCard = "_d-1";